import { useState } from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
const Tab1 = ({ parentcompany, fullcompanylist, accounts, pageState, onInputChange, handleChange }) => {
    const accountOptions = [
        { name: 'Test Account 1' },
        { name: 'Test Account 2' },
        { name: 'Test Account 3' },
    ];
    // console.log(fullcompanylist, "fullcompanylist");
console.log(parentcompany,"parentcompany");

    return (
        <div>
            <div className="px-2 py-3" style={{ background: 'white' }}>
                <div style={{ display: 'flex' }} >
                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <label style={{ height: '19px' }}></label>
                                    <Checkbox
                                        id="Is_Group_Warehouse"
                                        label="Is Group Warehouse"
                                        checked={pageState.isGroupWarehouse || false}
                                        onChange={(checked) => onInputChange("is_group", checked)}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <Input
                                        id="Warehouse Name"
                                        label="Warehouse Name"
                                        name='warehouseName'
                                        style={{ height: "30px" }}
                                        value={pageState.warehouseName}
                                        onChange={(e) => handleChange('warehouseName', e.target.value)}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <SelectSearch
                                        list={fullcompanylist || []}
                                        label="Company"
                                        getOptionLabel={(item) => item.name}
                                        getOptionValue={(item) => item.name}
                                        value={pageState.company}
                                        onChange={(val) => handleChange('company', val)}
                                        placeholder=""
                                    />
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <SelectSearch
                                        list={parentcompany || []}
                                        label="Parent Warehouse"
                                        getOptionLabel={(item) => item.name}
                                        getOptionValue={(item) => item.name}
                                        value={pageState.parentWarehouse}
                                        onChange={(val) => handleChange('parentWarehouse', val)}
                                        placeholder=""

                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <SelectSearch
                                        list={accounts || []}
                                        label="Account"
                                        getOptionLabel={(item) => item.name}
                                        getOptionValue={(item) => item.name}
                                        value={pageState.account}
                                        onChange={(val) => handleChange('account', val)}
                                        placeholder=""
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <Input
                                        id="Abbr"
                                        label="Abbr"
                                        name="abbr"
                                        style={{ height: "30px" }}
                                        value={pageState.abbr}
                                        onChange={(e) => handleChange('abbr', e.target.value)}

                                    />
                                </div>
                            </div>


                        </div>
                    </div>

                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Warehouse Contact Info</p>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>


                                <div style={{ flex: 1 }}>
                                    <Input
                                        id="Phone No."
                                        label="Phone No."
                                        name="phoneNo"
                                        style={{ height: "30px" }}
                                        value={pageState.phoneNo}
                                        onChange={(e) => handleChange('phoneNo', e.target.value)}
                                    />
                                </div>

                                <div style={{ flex: 1 }}>
                                    <Input
                                        id="Mobile No."
                                        label="Mobile No."
                                        name="mobileNo"
                                        style={{ height: "30px" }}
                                        value={pageState.mobileNo}
                                        onChange={(e) => handleChange('mobileNo', e.target.value)}
                                    />

                                </div>
                                <div style={{ flex: 1 }}>
                                    <Input
                                        id="Address Line 1"
                                        label="Address Line 1"
                                        name="addressLine1"
                                        style={{ height: "30px" }}
                                        value={pageState.addressLine1}
                                        onChange={(e) => handleChange('addressLine1', e.target.value)}
                                    />
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: '15px' }}>


                                <div style={{ flex: 1 }}>
                                    <Input
                                        id="Address Line 2"
                                        label="Address Line 2"
                                        name="addressLine2"
                                        style={{ height: "30px" }}
                                        value={pageState.addressLine2}
                                        onChange={(e) => handleChange('addressLine2', e.target.value)}
                                    />
                                </div>

                                <div style={{ flex: 1 }}>
                                    <Input
                                        id="County"
                                        label="County"
                                        style={{ height: "30px" }}
                                        value={pageState.county}
                                        name="county"
                                        onChange={(e) => handleChange('county', e.target.value)}
                                    />

                                </div>
                                <div style={{ flex: 1 }}>
                                    <Input
                                        id="State/Province"
                                        label="State/Province"
                                        name="stateProvince"
                                        style={{ height: "30px" }}
                                        value={pageState.stateProvince}
                                        onChange={(e) => handleChange('stateProvince', e.target.value)}
                                    />
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>


                                <div style={{ flex: 1 }}>
                                    <Input
                                        id="City/Town"
                                        label="City/Town"
                                        name="cityTown"
                                        style={{ height: "30px" }}
                                        value={pageState.cityTown}
                                        onChange={(e) => handleChange('cityTown', e.target.value)}
                                    />
                                </div>

                                <div style={{ flex: 1 }}>
                                    <Input
                                        id="Postal Code"
                                        label="Postal Code"
                                        name="postalCode"
                                        style={{ height: "30px" }}
                                        value={pageState.postalCode}
                                        onChange={(e) => handleChange('postalCode', e.target.value)}
                                    />

                                </div>
                                <div style={{ flex: 1 }}>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>


            </div>

        </div>
    );
};

export default Tab1;